<template>
  <!-- Content -->
  <div class="container-xxl flex-grow-1 container-p-y">
    <h4 class="fw-bold py-3 mb-4">
        <span class="text-muted fw-light">Category /</span> Edit
    </h4>

    <div class="row">
      <div class="card">
        <div class="row">
          <div class="col-md-7">
            <div class="card1">
              <div class="card-body">
                <div class="row">
                  <div class="mb-3 col-9">
                    <label for="apiAccess" class="form-label">Category Name</label>
                    <div class="position-relative">
                      <input type="text" 
                        class="form-control" 
                        name="category_name"
                        v-model="stateData.category_name"
                      >
                      <div class="error-msg" v-if="v$.stateData.category_name.$error"> 
                        {{ v$.stateData.category_name.$errors[0].$message }}
                      </div>
                    </div>
                  </div>
                  <div class="mb-3 col-3">
                    <label for="apiAccess" class="form-label">Symbol</label>
                    <div class="position-relative">
                      <input type="text" 
                        class="form-control" 
                        name="symbol"
                        v-model="stateData.symbol"
                      >
                      <div class="error-msg" v-if="v$.stateData.symbol.$error"> 
                        {{ v$.stateData.symbol.$errors[0].$message }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="mb-3 col-8">
                    <label for="apiAccess" class="form-label">Image</label>
                    <div class="position-relative">
                      <input 
                        class="form-control" 
                        type="file" 
                        accept=".jpg, .png"
                        id="image_link"
                        name="image-link"
                        @change="onFileChange"
                      >
                    </div>
                    <div class="mt-2" v-if="isUploadSuccess">
                      <span class="fw-bold text-success">The image is uploaded to server successfully.</span>
                    </div>
                    <div class="mt-2" v-if="isError">
                      <span class="fw-bold text-danger">The image isn't still uploaded to server.</span>
                    </div>
                    <div class="mt-2" v-if="isimageName">
                      <span class="text-info">{{ imageName }}</span>  
                    </div>
                  </div>
                  <div class="col-4">
                    <!-- <button id="button-upload" 
                      class="btn btn-warning me-1" 
                      @click="submitImageFile()" 
                      v-bind:disabled="isDisabledUpload"
                    >
                      Upload
                    </button> -->
                    <button id="button-clear-image" 
                      class="btn btn-warning" 
                      @click="clearImageFile()"
                    >
                      Clear
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="mb-3 col-12">
                    <label for="apiAccess" class="form-label">Description</label>
                    <div class="position-relative">
                      <textarea class="form-control" 
                        rows="5" 
                        name="description"
                        v-model="stateData.description"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <form id="" @submit.prevent="handleUpdate">
                    <div class="col-md-12 mb-3 plus-minus mt-3">
                      <button type="submit" class="btn btn-primary me-3">Update Category</button>
                      <router-link to="/category" data-i18n="Update Category" class="btn btn-outline-secondary w-45">
                        <i class='bx bx-arrow-back' ></i>
                        Back To Category
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="mb-3 col-md-10">
                <div class="p-4 category-left category-top" v-if="images.length == 0">
                  <img class="card-img-top card-img-bottom" :src='stateData.image_link ? domain + stateData.image_link : ""'>
                </div>
                <div class="p-4 category-left category-top" v-for="(image, key) in images" :key="key" v-else>
                  <img class="card-img-top card-img-bottom" :ref="'image'">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal modal-transparent show fade" v-if="isLoading" id="basicModal" style="display: block;">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <rise-loader :color="color" :size="size" style="text-align:center;"></rise-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- / Content -->
</template>

<script>
import useValidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { mapState } from "vuex";
import RiseLoader from 'vue-spinner/src/RiseLoader.vue'


export default {
  name: 'CategoryEdit',
  components: {
    RiseLoader
  },
  data() {
    return {
      v$: useValidate(),
      images: [],
      isError: false,
      isUploadSuccess: false,
      // isDisabledUpload: true,
      isimageName: true,
      isLoading: false,
      color: '#696cff',
      size: '20px',
      domain: process.env.VUE_APP_DOMAIN_FILE_SERVER
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.categoryAdd.stateData
    }),
    imageName: function() {
      if (!this.stateData.image_link) return "";
      
      let text = this.stateData.image_link.split("/");
      return text[text.length-1];
    }
  },
  beforeCreate() {
    this.$store.dispatch('categoryAdd/resetState');
  },
  created() {
    let paramID = this.$router.currentRoute._value.params.id;
    this.$store.dispatch('categoryAdd/getCategory', paramID).then(
      () => { 
        this.isimageName = true;
      },
      (error) => {
        console.log(error);
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Can not get the category data!'
        });
      }
    );
  },
  methods: {
    onFileChange(e) {
      let selectedFiles = e.target.files;
      if (selectedFiles.length > 0) {
        // this.isDisabledUpload = false;
        this.isError = false;
        this.isimageName = false;
        this.images = [];
        for (let i = 0; i < selectedFiles.length; i++) {
          this.images.push(selectedFiles[i]);
        }

        if (this.images.length > 0) {
          this.stateData.image_link = this.images[0].name;
        }
        
        for (let i = 0; i < this.images.length; i++) {
          let reader = new FileReader();
          reader.onload = () => {
              this.$refs.image[i].src = reader.result;
            };
            reader.readAsDataURL(this.images[i]);
        }

        // Handling upload file onto server
        this.submitImageFile();
      }
      // else {
      //   if (this.images.length > 0) {
      //     this.stateData.image_link = this.images[0].name;
      //   }
      // }
    },
    submitImageFile() {
      let formData = new FormData();

      for( let i = 0; i < this.images.length; i++ ){
        let file = this.images[i];
        formData.append("files", file);
      }
      this.isLoading = true;
      formData.append("service_name", "category");
      this.$store.dispatch('categoryAdd/uploadImage', formData).then(
        () => {
          this.isLoading = false;
          this.isUploadSuccess = true;
          // this.isDisabledUpload = true;
          this.isError = false;
          this.isimageName = false;
        },
        error => {
          console.log(error);
          this.isUploadSuccess = false;
          // this.isDisabledUpload = false;
          this.isError = true;
          this.isimageName = false;
          this.isLoading = false;
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to upload image !'
          });
        }
      );
    },
    clearImageFile() {
      this.images = [];
      let items =  this.$refs["image"];
      if (items != undefined){
        items.splice(0, items.length);
      }
      this.stateData.image_link = "";
      this.isUploadSuccess = false;
      // this.isDisabledUpload = false;
      this.isError = false;
      this.isimageName = false;
    },
    handleUpdate() {
      if (this.stateData.image_link !== "" && this.stateData.image_link !== null) {
        if (this.stateData.image_link.indexOf("___") == -1) {
          this.isError = true;
          window.scrollTo(0,0);
          return;
        }
      }
      this.v$.$validate();
      if (!this.v$.$error) {
        this.$store.dispatch('categoryAdd/updateCategory', this.stateData).then(
          () => {
            let self = this;
            this.$swal.fire(
              'Saved',
              'Category is updated sucessfully !',
              'success'
            ).then(function() {
              self.$router.push('/category');
            });
          },
          error => {
            console.log(error);
            this.$swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to save Category !'
            });
          }
        );
      }
    },
  },
  validations() {
    return {
      stateData: {
        category_name: {
          required: helpers.withMessage('Register Date cannot be empty', required)
        },
        symbol: { 
          required: helpers.withMessage('Consective No cannot be empty', required)
        }
      }
    }
  }
}
</script>